jQuery(document).ready(function($) {
    
	$('.gd-wc-faqs__single-heading').click(function() {
		$parent = $(this).parent('.gd-wc-faqs__single');
		$parent.toggleClass('--active');
	});
 
});